import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";
/*const getMenu = () => {
  return axios.get(process.env.REACT_APP_API_URL + "/menu", { headers: authHeader() });
};*/

const getMenu = () => {
	console.log(localStorage.getItem("menu"));
	var localMenu = localStorage.getItem("menu");
	if (localMenu && localMenu !== undefined && localMenu !== "undefined") {
		return Promise.resolve(JSON.parse(localStorage.getItem("menu")));
	}
	return axios
		.get(process.env.REACT_APP_API_URL + "/menu", { headers: AuthHeader.authHeader() })
		.then((response) => {
			if (response.data) {
				localStorage.setItem("menu", JSON.stringify(response.data));
			}
			return response.data;
		});
};

const getCatalog = (categoryParams) => {
	let config = {
		headers: AuthHeader.authHeader(),
		params: {
			categoryId: categoryParams[0],
			range: JSON.stringify([categoryParams[1], categoryParams[2]]),
			searchTerm: categoryParams[3],
			priceFilter: categoryParams[4],
			brandFilter: categoryParams[5],
			priceRange: categoryParams[6],
			colorFilter: categoryParams[7],
			genderFilter: categoryParams[8]
		},
	}

	return axios.get(process.env.REACT_APP_API_URL + "/catalog", config)
		.then((response) => {
			for (var i = 0; i < response.data.data.length; i++) {
				// Print items don't have colors - skip JSON parsing for them
				if (response.data.data[i].isPrintItem) {
					continue;
				}
				response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
			}
			return response.data;
		});
};

export const searchCatalog = async (search) => {
	try {
		console.log("SEARCH TERMS", search);
		let config = {
			headers: AuthHeader.authHeader(),
			params: {
				searchTerm: search[0],
				range: JSON.stringify([search[1], search[2]])
			},
		}

		const response = await axios.get(process.env.REACT_APP_API_URL + "/catalog/search/all", config);
		for (var i = 0; i < response.data.data.length; i++) {
			response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
		}
		return response.data;
	} catch (error) {
		console.log(error);
	}
};
const getAdminCatalog = () => {
	return axios
		.get(process.env.REACT_APP_API_URL + "/admin/catalog/0", { headers: AuthHeader.authHeader() })
		.then((response) => {
			return response.data;
		});
};

const searchAdminCatalog = async (searchTerm, range) => {
	let config = {
		headers: AuthHeader.authHeader(),
		params: {
			searchTerm: searchTerm,
			range: JSON.stringify(range)
		},
	}

	const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/catalog/search/all", config);
	for (var i = 0; i < response.data.data.length; i++) {
		response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
	}
	return response.data;
};


const loadNewSanmarProduct = async (styleId) => {
	let config = {
		headers: AuthHeader.authHeader(),
	}

	const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/sanmarLoadStyle/" + styleId, config);
	console.log("SANMAR ITEMS FOUND", response);

	return JSON.parse(response.data.data);
};


const addCatalogItem = async (items) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/addtocatalog",
		{
			"items": items.items,
			"decorationCode": items.decorationCode
		},
		{ headers: AuthHeader.authHeader() });
	if (response.status) console.log(response.status);
};

const addColorToCatalogItem = async (colorId, styleId) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/addcolor",
		{
			"colorId": colorId,
			"styleId": styleId
		},
		{ headers: AuthHeader.authHeader() });
	if (response.status) console.log(response.status);
};
const removeColorFromCatalogItem = async (colorId, styleId) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/removecolor",
		{
			"colorId": colorId,
			"styleId": styleId
		},
		{ headers: AuthHeader.authHeader() });
	if (response.status) console.log(response.status);
};

const getImagesForProduct = async (productId) => {
	let config = {
		headers: AuthHeader.authHeader(),
	}

	const response = await axios.get(process.env.REACT_APP_API_URL + "/images/" + productId, config);
	return response.data;
};

const getMainImageForProduct = async (productId) => {
	let config = {
		headers: AuthHeader.authHeader(),
	}

	const response = await axios.get(process.env.REACT_APP_API_URL + "/mainimage/" + productId, config);
	return response.data;
};

const removeFromCatalog = async (productId) => {
	let config = {
		headers: AuthHeader.authHeader(),
	}

	const response = await axios.delete(process.env.REACT_APP_API_URL + "/admin/removefromcatalog/" + productId, config);
	return response.data;
};

const deleteIgniteProduct = async (styleId) => {
	const response = await axios.delete(
		process.env.REACT_APP_API_URL + "/admin/igniteproducts/" + styleId,
		{ headers: AuthHeader.authHeader() }
	);
	return response.data;
};

const updateDescription = async (productId, description) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/updatedescription",
		{
			"productId": productId,
			"description": description
		},
		{ headers: AuthHeader.authHeader() });
	if (response.status) console.log(response.status);
};

const updateTitle = async (productId, title) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/updatetitle",
		{
			"productId": productId,
			"title": title
		},
		{ headers: AuthHeader.authHeader() });
	return response.data;
};

const toggleLight = async (colorId, value, prodictId) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/togglelight",
		{
			"colorId": colorId,
			"value": value,
			productId: prodictId
		},
		{ headers: AuthHeader.authHeader() });
	return response.data;
};

const getCatalogItem = async (itemId) => {
	const response = await axios.get(process.env.REACT_APP_API_URL + "/catalog/item/" + itemId, { headers: AuthHeader.authHeader() });

	for (var i = 0; i < response.data.items.length; i++) {
		response.data.items[i].sizes = JSON.parse(response.data.items[i].sizes);
		response.data.items[i].sizes.sort(function compareFn(a, b) {
			if (a.order < b.order) {
				return -1;
			}
			if (a.order > b.order) {
				return 1;
			}
			// a must be equal to b
			return 0;
		});
	}

	return response.data;
}
const updateAllSanmar = async () => {
	const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/updateAllSanmar", { headers: AuthHeader.authHeader() });
	return response.data;
}
const cloneProduct = async (productId, subsites) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/cloneProduct",
		{
			"productId": productId,
			"subsites": subsites
		},
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

// Get all new hire kits for the subsite
const getAllNewHireKits = async () => {
	const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/newhirekits",
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

// Create a new hire kit
const createNewHireKit = async (title) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/newhirekit/create",
		{ title },
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

// Update a new hire kit
const updateNewHireKit = async (kitId, title, displayOrder) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/newhirekit/update",
		{ kitId, title, displayOrder },
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

// Delete a new hire kit
const deleteNewHireKit = async (kitId) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/newhirekit/delete",
		{ kitId },
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

// Add item to a new hire kit (supports both kitId and legacy male param)
const addNewHireKitItem = async (productId, logos, kitIdOrMale) => {
	// Check if it's a boolean (legacy) or number (new kitId)
	const payload = {
		"productId": productId,
		"subsiteDecos": logos
	};

	if (typeof kitIdOrMale === 'boolean') {
		payload.male = kitIdOrMale;
	} else {
		payload.newHireKitId = kitIdOrMale;
	}

	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/newhirekititem",
		payload,
		{ headers: AuthHeader.authHeader() });
	if (response.status) console.log(response.status);
}

const removeNewHireKitItem = async (itemId) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/newhirekititem/remove",
		{ "id": itemId },
		{ headers: AuthHeader.authHeader() });
	if (response.status) console.log(response.status);
}

// Get kit settings (supports both kitId and legacy male param)
const getNewHireKitSettings = async (kitIdOrMale) => {
	const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/newhirekitsettings/" + kitIdOrMale,
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

// Update kit settings (supports both kitId and legacy male param)
const updateNewHireKitSettings = async (kitIdOrMale, useFixedPrice, fixedPrice) => {
	const payload = { useFixedPrice, fixedPrice };

	if (typeof kitIdOrMale === 'boolean') {
		payload.male = kitIdOrMale;
	} else {
		payload.kitId = kitIdOrMale;
	}

	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/newhirekitsettings",
		payload,
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

// Check existing NHK item (supports both kitId and legacy male param)
const checkExistingNHKItem = async (styleId, kitIdOrMale) => {
	const response = await axios.get(
		process.env.REACT_APP_API_URL + "/admin/newhirekititem/check/" + styleId + "/" + kitIdOrMale,
		{ headers: AuthHeader.authHeader() }
	);
	return response.data;
}

const addColorToNHKItem = async (existingNhkiId, productId, male) => {
	const response = await axios.post(
		process.env.REACT_APP_API_URL + "/admin/newhirekititem/addcolor",
		{
			existingNhkiId,
			productId,
			male
		},
		{ headers: AuthHeader.authHeader() }
	);
	return response.data;
}

const getNHKChoiceGroups = async (kitId) => {
	const response = await axios.get(
		process.env.REACT_APP_API_URL + "/admin/newhirekit/" + kitId + "/choicegroups",
		{ headers: AuthHeader.authHeader() }
	);
	return response.data;
}

const createNHKChoiceGroup = async (kitId, title) => {
	const response = await axios.post(
		process.env.REACT_APP_API_URL + "/admin/newhirekit/choicegroup",
		{ kitId, title },
		{ headers: AuthHeader.authHeader() }
	);
	return response.data;
}

const updateNHKChoiceGroup = async (id, data) => {
	const response = await axios.put(
		process.env.REACT_APP_API_URL + "/admin/newhirekit/choicegroup",
		{ id, ...data },
		{ headers: AuthHeader.authHeader() }
	);
	return response.data;
}

const deleteNHKChoiceGroup = async (id) => {
	const response = await axios.post(
		process.env.REACT_APP_API_URL + "/admin/newhirekit/choicegroup/delete",
		{ id },
		{ headers: AuthHeader.authHeader() }
	);
	return response.data;
}

const setNHKItemChoiceGroup = async (nhkiId, choiceGroupId) => {
	const response = await axios.post(
		process.env.REACT_APP_API_URL + "/admin/newhirekititem/choicegroup",
		{ nhkiId, choiceGroupId },
		{ headers: AuthHeader.authHeader() }
	);
	return response.data;
}

// Get kit items (supports both kitId and legacy male param)
const getNewHireKitItems = async (kitIdOrMale) => {
	const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/newhirekititems/" + kitIdOrMale, { headers: AuthHeader.authHeader() });
	return response.data;
}

const addProduct = async (product) => {
	const data = new FormData();

	data.append('productId', product.productId || '');
	data.append('description', product.description);
	data.append('categories', JSON.stringify(product.categories));
	data.append('title', product.title);
	data.append('modelCode', product.modelCode);
	data.append('price', product.price || 0);
	data.append('maker', product.maker);
	data.append('pricingType', product.pricingType || 1);
	data.append('quantityPrices', JSON.stringify(product.quantityPrices || []));
	data.append('productType', product.productType || '');

	// colorsData: array of { colorName, hexColor, sizes[] }
	// Per-color images use indexed field names: colorMainImage_0, colorAdditionalImages_0, etc.
	const colorsForJson = (product.colorsData || []).map(c => ({
		colorName: c.colorName,
		hexColor: c.hexColor,
		sizes: c.sizes
	}));
	data.append('colorsData', JSON.stringify(colorsForJson));

	(product.colorsData || []).forEach((colorEntry, i) => {
		if (colorEntry.mainImageFile) {
			data.append(`colorMainImage_${i}`, colorEntry.mainImageFile);
		}
		(colorEntry.additionalImageFiles || []).forEach(file => {
			data.append(`colorAdditionalImages_${i}`, file);
		});
	});

	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/addproduct", data,
		{
			headers: {
				...AuthHeader.authHeader(),
				'Content-Type': 'multipart/form-data'
			}
		});
	return response.data;
}

const limitProductToRole = async (productId, role, value) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/limitproducttorole",
		{
			"productId": productId,
			"role": role,
			"value": value
		},
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

const getProductCapabilities = async (productId) => {
	const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/productcapabilities/" + productId,
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

const limitProductToCapability = async (productId, capabilityId, value) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/limitproducttocapability",
		{
			"productId": productId,
			"capabilityId": capabilityId,
			"value": value
		},
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

const getImagesForStyleAndColor = async (productId, includeKitOnly = false) => {
	let config = {
		headers: AuthHeader.authHeader(),
	}

	const url = process.env.REACT_APP_API_URL + "/images/stylecolor/" + productId
		+ (includeKitOnly ? "?includeKitOnly=true" : "");

	try {
		const response = await axios.get(url, config);
		if (response && response.data) {
			return response.data;
		} else {
			console.error("No images found for productId:", productId);
			return { images: [] };
		}
	} catch (error) {
		console.error("Error fetching images for style and color:", error);
		return { images: [] };
	}
}

const addDecorationToImage = async (productId, locationId, logoId, selectedImage) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/addDecorationToImage",
		{
			"productId": productId,
			"decorationLogoId": logoId,
			"decoLocationId": locationId,
			"selectedImage": selectedImage.imageUrl
		},
		{ headers: AuthHeader.authHeader() });

	return response.data;
}

const removeDecorationFromImage = async (productId, locationId, logoId, selectedImage) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/removeDecorationFromImage",
		{
			"productId": productId,
			"decorationLogoId": logoId,
			"decoLocationId": locationId,
			"selectedImage": selectedImage.imageUrl
		},
		{ headers: AuthHeader.authHeader() });

	return response.data;
}

const markAsNew = async (productId, markAsNewValue) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/markasnew",
		{
			"productId": productId,
			"markAsNew": markAsNewValue
		},
		{ headers: AuthHeader.authHeader() });

	return response.data;
}

const toggleHidden = async (productId, hidden) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/togglehidden",
		{
			"productId": productId,
			"hidden": hidden
		},
		{ headers: AuthHeader.authHeader() });

	return response.data;
}

const getColors = async () => {
	const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/colors",
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

const getPersonalizationFields = async (styleId, subsiteId) => {
	const response = await axios.get(
		process.env.REACT_APP_API_URL + "/admin/personalization/style/" + styleId,
		{
			headers: AuthHeader.authHeader(),
			params: { subsiteId }
		}
	);
	return response.data;
}

const savePersonalizationFields = async (styleId, fields, subsiteId) => {
	const response = await axios.post(
		process.env.REACT_APP_API_URL + "/admin/personalization/style/" + styleId,
		{ fields, subsiteId },
		{ headers: AuthHeader.authHeader() }
	);
	return response.data;
}

const deletePersonalizationField = async (fieldId, subsiteId) => {
	const response = await axios.delete(
		process.env.REACT_APP_API_URL + "/admin/personalization/field/" + fieldId,
		{
			headers: AuthHeader.authHeader(),
			params: { subsiteId }
		}
	);
	return response.data;
}

const CatalogService = {
	getMenu,
	getCatalog,
	searchCatalog,
	getAdminCatalog,
	searchAdminCatalog,
	addCatalogItem,
	loadNewSanmarProduct,
	getImagesForProduct,
	removeFromCatalog,
	deleteIgniteProduct,
	getMainImageForProduct,
	updateDescription,
	updateTitle,
	toggleLight,
	addColorToCatalogItem,
	removeColorFromCatalogItem,
	getCatalogItem,
	updateAllSanmar,
	cloneProduct,
	getAllNewHireKits,
	createNewHireKit,
	updateNewHireKit,
	deleteNewHireKit,
	addNewHireKitItem,
	removeNewHireKitItem,
	checkExistingNHKItem,
	addColorToNHKItem,
	getNHKChoiceGroups,
	createNHKChoiceGroup,
	updateNHKChoiceGroup,
	deleteNHKChoiceGroup,
	setNHKItemChoiceGroup,
	getNewHireKitItems,
	getNewHireKitSettings,
	updateNewHireKitSettings,
	addProduct,
	limitProductToRole,
	getProductCapabilities,
	limitProductToCapability,
	getImagesForStyleAndColor,
	addDecorationToImage,
	removeDecorationFromImage,
	markAsNew,
	toggleHidden,
	getColors,
	getPersonalizationFields,
	savePersonalizationFields,
	deletePersonalizationField
};
export default CatalogService;